import { makeObservable, computed } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SpaceAccountCalendarConnectionModelData } from "@/store/calendar/space-account-calendar-connection/types";
import { SyncUpdateValue } from "@/store/sync/types";

export class SpaceAccountCalendarConnectionObservable extends BaseSyncModel<SpaceAccountCalendarConnectionModelData> {
  public modelKind = SyncModelKind.SpaceAccountCalendarConnection;

  constructor({
    id,
    data,
    store,
  }: {
    id: string;
    data: SyncUpdateValue<SpaceAccountCalendarConnectionModelData>;
  } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      modelKind: false,
      associatedSpaceAccountId: computed,
      associatedEmailAddress: computed,
      providerKind: computed,
    });
  }

  get associatedSpaceAccountId() {
    return this.modelData.associated_space_account_id;
  }

  get associatedEmailAddress() {
    return this.modelData.associated_email_address;
  }

  get providerKind() {
    return this.modelData.provider_kind;
  }
}
